import { Outlet } from '@remix-run/react'
import AppProviders from '~/providers/AppProviders'

export default function Routes() {
    return (
        <AppProviders>
            <Outlet />
        </AppProviders>
    )
}
